<script setup>
import { Link, usePage } from "@inertiajs/vue3";
import LogoDark from "@/Components/LogoDark.vue";
import { computed } from "vue";
import { PlusIcon } from '@heroicons/vue/24/solid';

const partner = computed(() => usePage().props?.partner)
const logoUrl = computed(() => partner.value?.logo_url)
</script>

<template>
    <Link href="/">
        <div class="flex sm:flex-row flex-col items-center gap-6 justify-center">
            <div>
                <LogoDark class="w-40" />
            </div>
            <PlusIcon class="size-4 text-allday-dark-800" v-if="logoUrl" aria-hidden="true" />
            <div v-if="logoUrl" class="relative">
                <img
                    :src="logoUrl"
                    :alt="partner?.name || 'Partner Logo'"
                    class="max-w-[200px] max-h-[80px] object-contain"
                    loading="lazy"
                />
            </div>
        </div>
    </Link>
</template>
